import { useState } from "react";

const FORMSPREE_URL = "https://formspree.io/f/xaqllwvp";

export default function Contact() {
  const [status, setStatus] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    const form = e.currentTarget;
    const data = new FormData(form);
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });
      if (res.ok) { setStatus("success"); form.reset(); }
      else setStatus("error");
    } catch { setStatus("error"); }
  };

  return (
    <div data-testid="contact-page">
      <section className="section pt-16">
        <div className="container-x max-w-3xl">
          <p className="tag">Contact</p>
          <h1 className="text-[40px] md:text-[52px] leading-[1.1] font-bold text-[#0F1A2A]">
            Demandez votre devis.
          </h1>
          <p className="mt-6 text-[17px] text-[#1F2A3D]">
            Indiquez-nous votre ville et la taille de votre installation. Nous revenons vers
            vous sous 24 h ouvrées avec un chiffrage personnalisé.
          </p>
        </div>
      </section>

      <section className="border-t border-[#E6E4DF] pb-20">
        <div className="container-x max-w-5xl py-12 grid md:grid-cols-3 gap-12">
          <aside className="md:col-span-1 space-y-8">
            <div>
              <p className="text-[13px] uppercase tracking-wider text-[#6B7280] mb-2">Email</p>
              <a href="mailto:optisolaires@gmail.com" data-testid="contact-email" className="link-accent">
                optisolaires@gmail.com
              </a>
            </div>
            <div>
              <p className="text-[13px] uppercase tracking-wider text-[#6B7280] mb-2">Délai de réponse</p>
              <p>Sous 24 h ouvrées</p>
            </div>
            <div>
              <p className="text-[13px] uppercase tracking-wider text-[#6B7280] mb-2">Zones</p>
              <ul className="space-y-1 text-[15px] text-[#1F2A3D]">
                <li>Blois (siège) — 20 rue de la Chocolaterie, 41000</li>
                <li>Tours — Orléans</li>
                <li>Paris &amp; Île-de-France</li>
                <li>Caen — Le Havre</li>
                <li>Nantes</li>
                <li>Strasbourg</li>
              </ul>
            </div>
          </aside>

          <div className="md:col-span-2">
            {status === "success" ? (
              <div data-testid="contact-success" className="border border-[#E6E4DF] rounded-md p-8 bg-[#F6F4EF]">
                <p className="font-semibold text-[#0F1A2A] text-lg">Merci, message bien reçu.</p>
                <p className="text-[#1F2A3D] mt-2">
                  Nous revenons vers vous sous 24 h ouvrées avec un chiffrage personnalisé.
                </p>
                <button onClick={() => setStatus("idle")} data-testid="contact-success-reset" className="btn btn-outline mt-6">
                  Envoyer une autre demande
                </button>
              </div>
            ) : (
              <form onSubmit={onSubmit} data-testid="contact-form" className="space-y-5">
                <div>
                  <label className="field-label">Nom et prénom</label>
                  <input type="text" name="nom" required data-testid="input-nom" className="field-input" />
                </div>
                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="field-label">Email</label>
                    <input type="email" name="email" required data-testid="input-email" className="field-input" />
                  </div>
                  <div>
                    <label className="field-label">Téléphone</label>
                    <input type="tel" name="tel" required data-testid="input-tel" className="field-input" />
                  </div>
                </div>
                <div>
                  <label className="field-label">Ville de l'installation</label>
                  <input
                    type="text"
                    name="lieu"
                    required
                    placeholder="Ex : Paris 16, Strasbourg, Caen…"
                    data-testid="input-lieu"
                    className="field-input"
                  />
                </div>
                <div>
                  <label className="field-label">Message (optionnel)</label>
                  <textarea
                    name="message"
                    rows={4}
                    placeholder="Nombre de panneaux, type de toit, accès…"
                    data-testid="input-message"
                    className="field-input resize-none"
                  />
                </div>

                {status === "error" && (
                  <p data-testid="contact-error" className="text-sm text-red-700 bg-red-50 border border-red-100 rounded p-3">
                    Une erreur est survenue. Réessayez ou écrivez-nous à optisolaires@gmail.com.
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "sending"}
                  data-testid="contact-submit"
                  className="btn btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {status === "sending" ? "Envoi…" : "Envoyer ma demande"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
